import axios from "axios";
import { BtixConstant } from "../constant";
/**
 * サーバーのAPIを呼び出し、フォームのvalidationを行う
 *
 * ここではvalidation及び、エラー時にメッセージを表示する部分までを担保している。
 * 下書き状態のvalidationを利用したい場合は、確認画面に遷移させるボタンに `data-draft-mode="true"` と記載しておくこと。
 *
 * @returns Promise<boolean>  問題無ければtrue, エラーならfalseが返ってくるので適宜 then/catch してやる。
 */
export const validateForm = async (target, formArea) => {
    const errorMessageAreaSelector = ".form-error-message";
    // const wanaAreaSelector = ".area-warn";
    const formInputAreaSelector = ".form-text";
    // const mainErrorClassName = "xxxxxxxx";
    const errorClassName = "form-error"; // ここはクエリセレクタで使わないので . は不要
    const previousErrorSelector = `.${errorClassName}`;
    if (!formArea || !(formArea instanceof HTMLFormElement))
        throw new Error("'formArea' must be form element.");
    // const warnArea = formArea.querySelector(wanaAreaSelector);
    // if (!warnArea) throw new Error("'warnArea' is not found.");
    const errorMessages = formArea.querySelectorAll(errorMessageAreaSelector);
    const previousErrors = formArea.querySelectorAll(previousErrorSelector);
    // エラー表示用のエリアを初期化
    // MEMO: 現時点でblade側の実装がどうなっているかわからないので一旦保留している
    // warnArea.classList.add(mainErrorClassName);
    errorMessages.forEach((message) => {
        message.innerHTML = "";
    });
    previousErrors.forEach((dom) => {
        dom.classList.remove(errorClassName);
    });
    // 送るデータを初期化
    const sendData = new FormData(formArea);
    const headers = {
        accept: "application/json",
        "Content-Type": "multipart/form-data",
    };
    // 下書きモードで作成する場合は draft_mode = 1 をPOSTデータに含める
    if (target.dataset.draftMode)
        sendData.set("draft_mode", "1");
    const actionUrl = new URL(formArea.action);
    // validationの実施 (APIへのデータ送信)
    const validationResult = await axios
        .post(`/api${actionUrl.pathname}/validate`, sendData, { withCredentials: true, headers: headers })
        .then((response) => {
        window.console.log(response);
        const validationMessages = response.data.errors;
        if (Object.keys(validationMessages).length === 0) {
            // バリデーションに引っかかったことを示すキーが無ければバリデーション問題なし
            return true;
        }
        // エラーメッセージの展開
        Object.keys(validationMessages).map((key) => {
            // MEMO: エラーは1つのフィールドに対して複数返ってくる可能性がある
            const errorMessageList = validationMessages[key];
            if (!errorMessageList)
                return;
            // HTML上は key[name][hoge] だが、JSでのレスポンスは key.name.hoge なのでパースしている
            let realHTMLName = key;
            const jsonNameArray = key.split(".");
            if (jsonNameArray.length > 1) {
                const first = jsonNameArray.shift();
                realHTMLName = first + "[" + jsonNameArray.join("][") + "]";
            }
            let errorTarget = formArea.querySelector(`[name="${realHTMLName}"]`);
            // NOTE: この時点で見つからないケースは以下の5つに分類される
            // ----
            // case1. propertyが存在しない → このケースは`throw Error`で対処する
            // case2. bracket付きのnameも探す必要がある
            // case3. [数字]を1回含む ex. key[0], key[0][hoge]
            // case4. [数字]を2回含む ex. key[0][hoge][0], key[0][hoge][0][hoge2]
            // case5. [数字]を3回以上含む → このケースは現在のコードに存在しないので`throw Error`で対処する
            // ----
            // case2
            if (!errorTarget) {
                errorTarget = formArea.querySelector(`[name='${realHTMLName}[]']`);
            }
            // case3 or case4 or case5
            if (!errorTarget) {
                const regex = /\[\d\]/g;
                const count = (realHTMLName.match(regex) || []).length;
                if (count === 1) {
                    // case3
                    const targetName = realHTMLName.replace(regex, "[]");
                    errorTarget = formArea.querySelector(`[name='${targetName}']`);
                }
                else if (count === 2) {
                    // case4
                    // 1. 前方置換
                    errorTarget = tryForwardReplacement(formArea, realHTMLName);
                    // 2. 後方置換
                    if (!errorTarget)
                        errorTarget = tryBackwardReplacement(formArea, realHTMLName);
                    // 3. 全置換
                    if (!errorTarget)
                        errorTarget = tryAllReplacement(formArea, realHTMLName);
                }
            }
            if (!errorTarget)
                throw new Error(`'errorTarget' for ${realHTMLName} is not found.`);
            const errorArea = errorTarget.closest(formInputAreaSelector);
            if (BtixConstant.debugMode)
                window.console.log("realHTMLName", realHTMLName);
            if (!errorArea)
                throw new Error("'errorArea' is not found.");
            const messageArea = errorArea.querySelector(errorMessageAreaSelector);
            if (!messageArea)
                throw new Error("'messageArea' is not found.");
            errorArea.classList.add(errorClassName);
            messageArea.innerHTML = errorMessageList.join("<br>");
        });
        // バリデーションに引っかかった場合は確認画面に進ませない
        return false;
    })
        .catch((error) => {
        if (!axios.isAxiosError(error)) {
            window.console.log(error);
            throw new Error("Error occured.");
        }
        if (BtixConstant.debugMode)
            window.console.log(error.response);
        // エラーが返って来たら確認画面に進ませない
        return false;
    });
    return validationResult;
};
// 前方置換
const tryForwardReplacement = (formArea, realHTMLName) => {
    const regex = /\[\d+\]/;
    const targetName = realHTMLName.replace(regex, "[]");
    const errorTarget = formArea.querySelector(`[name='${targetName}']`);
    return errorTarget;
};
// 後方置換
const tryBackwardReplacement = (formArea, realHTMLName) => {
    // NOTE: 本来はこちらを使うべきだが、Safariでエラーになる（JS全体が動かなくなる）ので lookbehind を使わないようにした
    // ref: https://caniuse.com/?search=lookbehind
    // const regex = /(?<=[[\[\d+\]])\[\d+\]/;
    // const targetName = realHTMLName.replace(regex, "[]");
    const regex = /\[\d+\]/g;
    const matches = realHTMLName.match(regex);
    if (matches == null) {
        return null;
    }
    // NOTE: 後方マッチした場所を境に2つの文字に分割して、後方の文字のみreplaceして繋ぎ合わせる
    const targetIndex = realHTMLName.lastIndexOf(matches[1]);
    const front = realHTMLName.slice(0, targetIndex);
    const v = realHTMLName.slice(targetIndex, realHTMLName.length);
    const back = v.replace(regex, "[]");
    const errorTarget = formArea.querySelector(`[name='${front}${back}']`);
    return errorTarget;
};
// 全置換
const tryAllReplacement = (formArea, realHTMLName) => {
    const regex = /\[\d+\]/g;
    const targetName = realHTMLName.replace(regex, "[]");
    const errorTarget = formArea.querySelector(`[name='${targetName}']`);
    return errorTarget;
};
